import { useSelector } from 'react-redux';

import { RootState } from '../redux/store';
import { isLoggedIn } from '../utils/utils';
import { Navigate } from 'react-router-dom';
import { NAVIGATE_ADMIN, NAVIGATE_AGENT, NAVIGATE_AUTH } from '../constant';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
    const authUser = useSelector((state: RootState) => state.authUser);
    if (isLoggedIn(authUser)) {
        const userType = authUser?.user_details?.user_type;
        if (userType === 'admin') {
            return <Navigate to={NAVIGATE_ADMIN.DASHBOARD_PAGE} />;
        } else if (userType === 'hospital' || userType === 'blood_bank') {
            return <Navigate to={NAVIGATE_ADMIN.PROFILE_PAGE} />;
        } else if (userType) {
            return <Navigate to={NAVIGATE_AGENT.CALLS_DASHBOARD_PAGE} />;
        } else {
            console.warn("AuthLayout: User is logged in but user_type is undefined or invalid. Redirecting to login.");
            localStorage.removeItem('user_auth_session'); // Optionally clear session
            return <Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />;
        }
    }

    return (
        <>{children}</>
    )
}

export default AuthLayout;